module.exports = __webpack_public_path__ + "img/left_right_layout_3_old.4a5a22fa.svg";